import { Select, Spin, Typography } from 'antd';
import React, { useCallback, useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { readTenantsAction } from '../../redux-store/tenants-store';
import settings from '../../settings';
import useMany from '../../shared/use-many';
import { allTenantsQuery } from './constants';
import useProfile from '../../shared/use-profile';

const { Text } = Typography;

function SelectMyTenant({
  disabled,
  createNewTenant,
  value,
  onChange,
  filters,
}) {
  const profile = useProfile();
  const tenant = useMemo(() => {
    return (
      (profile.tenantId && {
        _id: profile.tenantId,
        name: profile.tenant.name,
      }) ||
      {}
    );
  }, [profile]);
  const locale = useSelector((store) => store.locale, shallowEqual);
  return (
    <Select disabled={disabled} onChange={onChange} value={tenant._id}>
      <Select.Option key={tenant._id} value={tenant._id} title={tenant.name}>
        <div className="tenant-option">
          <div>
            <Text>{tenant.name}</Text>
          </div>
        </div>
      </Select.Option>
    </Select>
  );
}

export default SelectMyTenant;
